"use client"

import { Link } from "components/Navigation/Shared/Link"
import { useRouter } from "lib/router"
import React from "react"
import { siteUrl } from "utils/getSiteUrl"
import type { PropsIconsObject } from "./ShareIcons.config"
import { iconsObject } from "./ShareIcons.config"
import { colours } from "@shared/ui.design-system"

type Props = {
  variant?: string
  icons: string[]
  direct?: boolean
  pinterestImageUrl?: string
  color?: string
}
const getUrl = (href: string) => (typeof href === "string" ? href : undefined)

export const ShareIcons: React.FC<Props> = ({
  icons,
  direct = false,
  pinterestImageUrl,
  color = colours.primary.dark,
}) => {
  const router = useRouter()

  return (
    <>
      {icons.map((service) => {
        const { href, shareHref, ShareIcon }: PropsIconsObject =
          iconsObject[service]

        let hrefRendered

        if (direct) {
          hrefRendered = href
        } else {
          const pinterestQueryParam =
            service === "pinterest" && pinterestImageUrl
              ? `&media=${pinterestImageUrl}`
              : ""

          hrefRendered = getUrl(
            `${shareHref}${siteUrl}${router?.asPath}${pinterestQueryParam}`
          )
        }

        return (
          <Link
            key={service}
            href={hrefRendered}
            target="_blank"
            aria-label={`Share on ${service}`}
            title={`Share on ${service}`}
            rel="noreferrer"
            data-testid={service}
          >
            <ShareIcon id={service} color={color} />
          </Link>
        )
      })}
    </>
  )
}
